import { render } from "./informationRisks.vue?vue&type=template&id=903fa7cc&scoped=true&ts=true"
import script from "./informationRisks.vue?vue&type=script&lang=ts"
export * from "./informationRisks.vue?vue&type=script&lang=ts"

import "./informationRisks.vue?vue&type=style&index=0&id=903fa7cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-903fa7cc"]])

export default __exports__